import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import { Route, Switch } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'

import LineItemsIndexPage from '../containers/LineItems'

import appActions from '../redux/app/actions'

const { changeCurrent } = appActions

const LineItemsPage = ({ location, match }) => {
  const dispatch = useDispatch()
  const current = useSelector(state => state.getIn(['App', 'current'])).toJS()
  const { pathname } = location

  useEffect(() => {
    if (current[0] !== 'line_items') {
      dispatch(changeCurrent(['line_items']))
    }
  }, [pathname])

  const path = match.url

  return (
    <Switch>
      <Route path={`${path}/`} component={LineItemsIndexPage} exact />
    </Switch>
  )
}

LineItemsPage.propTypes = {
  location: PropTypes.object.isRequired,
  match: PropTypes.object.isRequired
}

export default LineItemsPage
